import styled from '@emotion/styled/macro';
import { Variables } from '../base/variables';

const V = Variables.ThemeLight;

/** `BaseDialog` pads only its title; the content brings its own inset. */
export const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    min-width: 0;
    padding: 0 24px 24px;
    font-size: 14px;
    color: ${V.TextMedium};
`;

export const Text = styled.p`
    margin: 0;
    line-height: 1.5;
`;

export const Note = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.45;
    background: ${V.PrimaryMild2};
    color: ${V.PrimaryInverted3};

    svg {
        flex: none;
        margin-top: 1px;
    }
`;

export const Buttons = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
`;

export const Filters = styled.div`
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 12px;
`;

export const DateField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 170px;
`;

export const Label = styled.span`
    font-size: 12px;
    font-weight: 500;
    color: ${V.TextMedium};
`;

export const Presets = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
`;

export const CountRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    color: ${V.TextMild};
`;

/**
 * The table scrolls inside this frame, never the dialog: without `min-width: 0` the flex item grows
 * to the table's width and the whole dialog body scrolls sideways, hiding the checkbox column.
 */
export const TableFrame = styled.div`
    min-width: 0;
    max-height: 360px;
    overflow: auto;
    border: 1px solid ${V.Border1};
    border-radius: 6px;
`;

export const Locked = styled.span`
    display: inline-flex;
    color: ${V.TextXMild};
`;

export const Footer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

export const ToggleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: ${V.TextStrong};
`;
